module.exports = __webpack_public_path__ + "img/SL-M-100-160.560c54a4.svg";